<doc>鼠标绘制工具</doc>
<template>
  <div class="draw-div">
    <el-button class="draw-btn" @click="draw()">绘制</el-button>
    <el-button class="draw-btn" @click="edit()">编辑</el-button>
    <el-button class="draw-btn" @click="del()">删除</el-button>
    <el-button class="draw-btn" @click="finish()">完成</el-button>
  </div>
</template>
<script>
import store from "../../../store"
export default {
  props: ["mapObject"],

  data() {
    return {};
  },
  mounted(){
    
  },
  methods: {
    // 开始绘制
    draw() {
      // this.mapObject.setCenter([101.51,38.84])//中心点切换
      this.mapObject.registClick(0)
      this.mapObject.drawPolygon("drawPolygon").then((points) => {
        this.$emit("drawFinsh", points);
      }); // 开始绘制多边形覆盖物
    },

    // 编辑
    edit() {
      this.mapObject.registClick(0)
      this.mapObject.editDrawPolygon()
    },

    // 完成
    finish() {
      this.mapObject.finishDrawPolygon("drawPolygon").then((points) => {
        this.$emit("drawFinsh", points);
      });
    },

    // 删除
    del() {
      this.mapObject.removeInteractionForPolygon();
      this.mapObject.removeVectorLayer("drawPolygon");
      store.commit('mapMesChange', {})
    },
  },
};
</script>
<style scoped>
.draw-div {
  position: absolute;
  right: 20px;
  top: 10px;
  font-size: 12px;
  padding: 5px 10px;
  background-color: #fff;
  box-shadow: 0 2px 2px rgb(0 0 0 / 15%);
  width: 140px;
}

.draw-btn {
  width: 100%;
  margin: 5px 0;
  cursor: pointer;
}
</style>
